module.exports = __webpack_public_path__ + "img/art_3_6.fd07097c.png";